import { createReducer, on } from '@ngrx/store';
import {
  NotificationContentFormErroredAction,
  NotificationContentFormLoadAction,
  NotificationContentFormLoadErroredAction,
  NotificationContentFormLoadSucceededAction,
  NotificationContentFormModeChangedAction,
  NotificationContentFormUpdatedAction,
} from './notification-content-form.actions';
import { ViewNotificationContent } from 'studio-components';
import { FormMode, NotificationContentFormApiError } from './types';

export interface NotificationContentFormState {
  model: ViewNotificationContent;
  mode: FormMode;
  loaded: boolean;
  error: NotificationContentFormApiError;
}

const initialState: NotificationContentFormState = {
  model: null,
  mode: FormMode.View,
  loaded: false,
  error: null,
};

export const notificationContentFormReducer = createReducer(
  initialState,
  on(NotificationContentFormLoadAction, (state) => ({
    ...state,
    error: null,
    loaded: false,
    model: null,
    mode: FormMode.View,
  })),
  on(
    NotificationContentFormLoadSucceededAction,
    NotificationContentFormUpdatedAction,
    (state, { notificationContent }) => ({
      ...state,
      loaded: true,
      model: notificationContent,
      error: null,
    }),
  ),
  on(NotificationContentFormModeChangedAction, (state, { mode }) => ({
    ...state,
    mode,
    model: mode === FormMode.Create ? null : state.model,
    loaded: false,
    error: null,
  })),
  on(
    NotificationContentFormErroredAction,
    NotificationContentFormLoadErroredAction,
    (state, { error }) => ({
      ...state,
      error,
      loaded: false,
      model: null,
    }),
  ),
);
